import React from 'react'

//Biibliotecas
import styled from 'styled-components';
import {useNavigate} from 'react-router-dom';

//Componentes
import Button from '../components/common/Button';

//Imágenes
import notFound from '../assets/images/404.png';
import {CornerUpLeft} from 'react-feather';


function NotFound() {
    //React Dom Router
    const navigate = useNavigate();
    return (
        <Container>
            <Message className='div1'>
                <h1>404</h1>
                <h2>Página no encontrada</h2>
            </Message>
            <Information className='div2'>
                <span>Oops!</span>
                <span>Parece que perdiste tu camino</span>
                <p>La página que estás buscando no existe o no se encuentra disponible.</p>
                <Button onClick={()=>{navigate("/")}}><CornerUpLeft/>Regresar a inicio</Button>
            </Information>
            <Image src={notFound} className='div3'></Image>
        </Container>
    )
}

export default NotFound;

const Container = styled.div`
    box-sizing: border-box;
    background: rgb(86,11,173);
    background: -moz-linear-gradient(90deg, rgba(86,11,173,1) 0%, rgba(58,12,163,1) 100%);
    background: -webkit-linear-gradient(90deg, rgba(86,11,173,1) 0%, rgba(58,12,163,1) 100%);
    background: linear-gradient(90deg, rgba(86,11,173,1) 0%, rgba(58,12,163,1) 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#560bad",endColorstr="#3a0ca3",GradientType=1);
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(4, 1fr);
    grid-column-gap: 0px;
    grid-row-gap: 0px;
    .div1 { grid-area: 1 / 2 / 2 / 3; }
    .div2 { grid-area: 2 / 3 / 4 / 4; }
    .div3 { grid-area: 1 / 1 / 5 / 4; }
    height: 100vh;
    overflow:hidden;
`;

const Image = styled.img`
    z-index:0;
    width:100%;
    align-self:flex-end;
`;

const Message = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    color: var(--color-blanco);
    z-index:1;

    h1{
        font-size: 96px;
    }
    h2{
        font-size:32px;
    }
`;


const Information= styled.div`
    background-color: var(--color-blanco);
    display:flex;
    flex-direction:column;
    align-items:center; 
    justify-content:center; 
    text-align:center;
    margin:32px;
    background: rgba(255, 255, 255, 0.3);
    background-blend-mode: soft-light;
    backdrop-filter: blur(20px);
    border-radius: 15px;
    padding: 24px;
    z-index:2;
    height:80%;
    
    span:first-child{ 
        font-size: 2.441rem;
        font-weight: 900;
        color: var(--color-morado-claro);
    
    }
    span:nth-child(2){
        font-size: 1.441rem;
        font-weight: 700;
        margin-bottom: 16px;
        color: var(--color-negro);
    }
    p{
        margin-bottom:32px;
    }
   
`;